import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import {
  getRoutePath,
  isRoutePath,
  localizePathname,
  normalizeRouteLanguage,
  resolveRouteKey,
  routeBelongsToGroup,
  startsWithRoutePath,
} from '../routes/localizedRoutes';

export const useLocalizedRoutes = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  const language = normalizeRouteLanguage(
    i18n.resolvedLanguage || i18n.language,
  );

  return {
    language,
    currentRouteKey: resolveRouteKey(location.pathname),
    getPath: (routeKey) => getRoutePath(routeKey, language),
    isCurrentRoute: (routeKey) => isRoutePath(location.pathname, routeKey),
    localizePath: (pathname) => localizePathname(pathname, language),
    routeBelongsToGroup: (routeGroup) =>
      routeBelongsToGroup(location.pathname, routeGroup),
    startsWithRoute: (routeKey) => startsWithRoutePath(location.pathname, routeKey),
  };
};
